import Immutable, { List, Map, Seq } from 'immutable';
import { API } from '../../../Root';
import { catchBlockErrors } from '../../../shared/utils/sentry';

// davis adds
const ADD_NEW_TRUCK = 'ADD_NEW_TRUCK';
export const addNewTruck = (newTruck) => {
    return {
        type: ADD_NEW_TRUCK,
        payload: newTruck,
    }
};

// Add a truck to the list without opening it (used by copy — stay on the dashboard).
const ADD_TRUCK_TO_LIST = 'ADD_TRUCK_TO_LIST';
export const addTruckToList = (newTruck) => ({
    type: ADD_TRUCK_TO_LIST,
    payload: newTruck,
});


const setPending = (value) => ({
    type: 'setPending',
    payload: value
});

const setError = (error) => ({
    type: 'setError',
    payload: error || null
});

const SET_ALL_TRUCKS = 'SET_ALL_TRUCKS';
export const setTrucks = (data) => ({
    type: SET_ALL_TRUCKS,
    payload: data
});

export const setTruckId = (id, _truckIndex, readOnly = false) => ({
    type: 'setTruckId',
    payload: {id, _truckIndex, readOnly}
});

const SET_READ_ONLY = 'SET_READ_ONLY';
export const setReadOnly = (value) => ({
    type: SET_READ_ONLY,
    payload: value
});

export const setTruckTypes = (truckTypes) => ({
    type: 'setTruckTypes',
    payload: truckTypes
});

export const updateCarriages = (keyPath, carriageUpdate) => ({
    type: 'updateCarriages',
    payload: {
        keyPath,
        carriageUpdate,
    },
});
const SLOT_UPDATE = 'SLOT_UPDATE';
export const updateSlot = (_carriageName, slotRank, slotColumn, slotValue) => ({
    type: SLOT_UPDATE,
    payload: {_carriageName, slotRank, slotColumn, slotValue}
});

const ADDRESS_UPDATE = 'ADDRESS_UPDATE';
export const updateAddress = (address, itemIndex) => ({
    type: ADDRESS_UPDATE,
    payload: {address, itemIndex}
});

const SERIAL_NUMBER_UPDATE = 'SERIAL_NUMBER_UPDATE';
export const updateSerialNumber = (serialNumber, itemIndex) => ({
    type: SERIAL_NUMBER_UPDATE,
    payload: {serialNumber, itemIndex}
});

const DELETE_TRUCK_ITEM = 'DELETE_TRUCK_ITEM';
export const deleteTruckItem = (indexForRemoval) => ({
    type: DELETE_TRUCK_ITEM,
    payload: indexForRemoval,
});

const ADD_IMPORTED_TRUCK_ITEMS = 'ADD_IMPORTED_TRUCK_ITEMS';
export const addImportedTruckItems = (items) => ({
    type: ADD_IMPORTED_TRUCK_ITEMS,
    payload: items,
});

export { 
    addHardwareItemWithDependencies,
    UPDATE_TRUCK_ITEMS,
} from '../tabs/hardware/store/hardwareThunks';

const SET_RAISERS = 'SET_RAISERS';
export const setRaisers = (carriageID, raiserID, updatedValue) => ({
    type: SET_RAISERS,
    payload: {
        carriageID,
        raiserID,
        updatedValue
    }
});

const UPDATE_TRUCK = 'UPDATE_TRUCK';
export const updateTruckAfterSave = (freshTruckObject) => ({
    type: UPDATE_TRUCK,
    payload: {
        freshTruckObject,
    }
});

const IO_UPDATE = 'IO_UPDATE';
export const updateIOValue = (rowIndex, ioIndex, updateKey, newValue) => ({
    type: IO_UPDATE,
    payload: {
        rowIndex,
        ioIndex,
        updateKey,
        newValue,
    }
});
const UPDATE_RANKS = 'UPDATE_RANKS';
export const updateRanks = (ranksAmount, _carriageType) => ({
    type: UPDATE_RANKS,
    payload: {ranksAmount, _carriageType}

});

const UPDATE_COLUMNS = 'UPDATE_COLUMNS';
export const updateColumns = (columnsAmount, carriageType) => ({
    type: UPDATE_COLUMNS,
    payload: {columnsAmount, carriageType}

});

const UPDATE_CARRIAGE = 'UPDATE_CARRIAGE';
export const updateCarriage = (carriageUpdate) => ({
    type: UPDATE_CARRIAGE,
    payload: carriageUpdate

});

const SET_TRUCK_FEATURES = 'SET_TRUCK_FEATURES';
export const setTruckFeatures = (featureIdList) => ({
    type: SET_TRUCK_FEATURES,
    payload: featureIdList
});

const SET_TRUCK_FEATURES_CUSTOM = 'SET_TRUCK_FEATURES_CUSTOM';
export const setTruckFeaturesCustom = (customFeaturesInstructions) => ({
    type: SET_TRUCK_FEATURES_CUSTOM,
    payload: customFeaturesInstructions
});

const SET_HARDWARE_CHANGE = 'SET_HARDWARE_CHANGE';
export const setHardwareChange = (value) => ({
    type: SET_HARDWARE_CHANGE,
    payload: value
});

const SET_UNSAVED_CHANGES = 'SET_UNSAVED_CHANGES';
export const setUnsavedChanges = (value) => ({
    type: SET_UNSAVED_CHANGES,
    payload: value
});

export const updateTruck = (data, merge = true, dirty = true) => ({
    type: 'updateTruck',
    payload: {
        data,
        merge,
        dirty
    }
});


export const copyTruck = (id) => async function (dispatch, getState) {

    try {
        dispatch(setPending(true));
        const copiedTruck = await API.call({
            endpoint: API.endpoints['TD/copyTruck'],
            method: 'POST',
            options: {
                params: { uid: id }
            }
        });

        if (copiedTruck.error) throw copiedTruck.error;

        // Copy lands in the list but does NOT open — stay on the dashboard.
        dispatch(addTruckToList(copiedTruck));
    } catch (e) {
        console.error(e);
        dispatch(setError(e));
        catchBlockErrors({ error: e, fileFunction: 'truckDesigner/truckStore/copyTruck' });
    }

    dispatch(setPending(false));
}


const INITIAL_STATE = Immutable.fromJS({
    dirty: false,
    pending: false,
    error: null,
    selectedTruck: {},
    truckBackup: null,
    trucks: [],
    truckTypes: [],
    hardwareChange: false,
    hasUnsavedChanges: false,
    readOnly: false,
})

const TruckReducer = function (state = INITIAL_STATE, action) {
    const reduce = {
        IO_UPDATE({
            rowIndex,
            ioIndex,
            updateKey,
            newValue,
        }){
            if (state.get('hardwareChange')) {
                return state.setIn([
                    'selectedTruck',
                    'truckItems',
                    rowIndex,
                    'iocomponents',
                    ioIndex,
                    updateKey,
                ], newValue)
                .set('hasUnsavedChanges', true);
            }
            return state
                .setIn([
                    'selectedTruck',
                    'truckItems',
                    rowIndex,
                    'iocomponents',
                    ioIndex,
                    updateKey,
                ], newValue)
                .set('hardwareChange', true)
                .set('hasUnsavedChanges', true);

        },
        setTruckTypes(truckTypes){
            console.log('here', truckTypes);
            return state.set('truckTypes', truckTypes);
        },

        updateCarriages({keyPath, carriageUpdate}){

            const _keyPath = ['selectedTruck', 'carriageLayout'].concat(keyPath);
            return state
                .setIn(_keyPath, carriageUpdate)
                .set('hasUnsavedChanges', true);
        },

        setTruckId({id, _truckIndex, readOnly = false}) {
            const nextTruckIndex = state.hasIn(['trucks', _truckIndex + 1]) ? _truckIndex + 1 : null;
            const prevTruckIndex = _truckIndex > 0 && state.hasIn(['trucks', _truckIndex - 1]) ? _truckIndex - 1 : null;
            return state
                .set('selectedTruckIndex', _truckIndex)
                .set('selectedTruck', id)
                .set('nextTruckIndex', nextTruckIndex)
                .set('prevTruckIndex', prevTruckIndex)
                .set('hasUnsavedChanges', false)
                .set('hardwareChange', false)
                .set('readOnly', readOnly);
        },

        SET_READ_ONLY(value) {
            return state.set('readOnly', value);
        },
        UPDATE_RANKS({ranksAmount, _carriageType}){
            const RANK_CARRIAGE_UPDATE_KEY = [
                'selectedTruck', 'carriageLayout', _carriageType, 'layout'
            ];

            const currentLayout =  state.getIn(
                RANK_CARRIAGE_UPDATE_KEY, List([])
            )
            const currentColumnCount = state.get('currentColumnCount', 0);
            const defaultRankRow = List().setSize(currentColumnCount).map(() => '');

            let updatedRanksLayout = List([]);
            for(let index = 0; index < ranksAmount; index++){
                const _updatedRank = currentLayout.get(index, defaultRankRow);
                updatedRanksLayout = updatedRanksLayout.push(_updatedRank);
            }
            return state
                .setIn(RANK_CARRIAGE_UPDATE_KEY, updatedRanksLayout)
                .set('hasUnsavedChanges', true);

        },

        UPDATE_TRUCK({freshTruckObject}){
            console.log('freshTruckObject', freshTruckObject.toJS());
            const _index = state.get('trucks').findIndex(truck => {
                return truck.get('_id') === freshTruckObject.get('_id')
            });
            console.log('_index', _index);
            const newState = state
                .set('selectedTruck', freshTruckObject)
                .setIn(['trucks', _index], freshTruckObject)
                .set('hardwareChange', false)
                .set('hasUnsavedChanges', false);
            console.log('newState', newState.toJS());
            return newState;
        },
        
        SET_RAISERS({carriageID, raiserID, updatedValue}){
            return state
                .setIn(['selectedTruck', 'carriageLayout', carriageID, raiserID], updatedValue)
                .set('hasUnsavedChanges', true);
        },

        SLOT_UPDATE({_carriageName, slotRank, slotColumn, slotValue}){

            const SLOT_CARRIAGE_UPDATE_KEY = [
                'selectedTruck', 'carriageLayout', _carriageName, 'layout', slotRank, slotColumn
            ];
            return state
                .setIn(SLOT_CARRIAGE_UPDATE_KEY, slotValue)
                .set('hasUnsavedChanges', true);
        },
        UPDATE_COLUMNS({columnsAmount, carriageType}){
            const COLUMN_CARRIAGE_UPDATE_KEY = [
                'selectedTruck', 'carriageLayout', carriageType, 'layout'
            ];

            const currentLayout =  state.getIn(
                COLUMN_CARRIAGE_UPDATE_KEY, List([])
            )
            const updatedColumnLayout = currentLayout.map((row, rowIndex) => {
                let newRow = List([]);
                for(let index = 0; index < columnsAmount; index++){
                    const value = currentLayout.getIn([rowIndex, index], '');
                    newRow = newRow.push(value);
                };
                return newRow;
            });
            return state
                .set('currentColumnCount', columnsAmount)
                .setIn(COLUMN_CARRIAGE_UPDATE_KEY, updatedColumnLayout)
                .set('hasUnsavedChanges', true);

        },

        updateTruck({ data, merge, dirty }) {
            let _selectedTruck = state.get('selectedTruck', null)
            if (_selectedTruck === null) return state;

            _selectedTruck = _selectedTruck.set(data[0], data[1]);
            return state
                .set('selectedTruck', _selectedTruck)
                .set('dirty', dirty)
                .set('hasUnsavedChanges', true);
        },
        ADDRESS_UPDATE({address, itemIndex}) {
            if (state.get('hardwareChange')) {
                return state
                    .setIn(['selectedTruck', 'truckItems', itemIndex, 'address'], address)
                    .set('hasUnsavedChanges', true);
            }
            return state
                .setIn(['selectedTruck', 'truckItems', itemIndex, 'address'], address)
                .set('hardwareChange', true)
                .set('hasUnsavedChanges', true);
        },

        SERIAL_NUMBER_UPDATE({serialNumber, itemIndex}) {
            if (state.get('hardwareChange')) {
                return state
                    .setIn(['selectedTruck', 'truckItems', itemIndex, 'serial_number'], serialNumber)
                    .set('hasUnsavedChanges', true);
            }
            return state
                .setIn(['selectedTruck', 'truckItems', itemIndex, 'serial_number'], serialNumber)
                .set('hardwareChange', true)
                .set('hasUnsavedChanges', true);
        },

        DELETE_TRUCK_ITEM(indexForRemoval) {

            const truckItemRemoved = state.getIn(
                ['selectedTruck', 'truckItems'], List([])
            ).delete(indexForRemoval);

            if (state.get('hardwareChange')) {
                return state
                    .setIn(['selectedTruck', 'truckItems'], truckItemRemoved)
                    .set('hasUnsavedChanges', true);
            }
            return state
                .setIn(['selectedTruck', 'truckItems'], truckItemRemoved)
                .set('hardwareChange', true)
                .set('hasUnsavedChanges', true);
        },
        ADD_IMPORTED_TRUCK_ITEMS(items) {
            const existing = state.getIn(['selectedTruck', 'truckItems'], List([]));
            const merged = existing.concat(Immutable.fromJS(items));
            return state
                .setIn(['selectedTruck', 'truckItems'], merged)
                .set('hardwareChange', true)
                .set('hasUnsavedChanges', true);
        },

        UPDATE_TRUCK_ITEMS(truckItem) {
            const truckItemsUpdate = state.getIn(['selectedTruck', 'truckItems'], List([])).push(truckItem);
            if (state.get('hardwareChange')) {
                return state
                    .setIn(['selectedTruck', 'truckItems'], truckItemsUpdate)
                    .set('hasUnsavedChanges', true);
            }
            return state
                .setIn(['selectedTruck', 'truckItems'], truckItemsUpdate)
                .set('hardwareChange', true)
                .set('hasUnsavedChanges', true);
        },

        SET_TRUCK_FEATURES(featureIdList) {
            return state
                .setIn(['selectedTruck', 'enabledFeatures'], featureIdList)
                .set('hasUnsavedChanges', true);
        },

        SET_TRUCK_FEATURES_CUSTOM(customFeaturesInstructions) {
            return state
                .setIn(['selectedTruck', 'customFeatures'], customFeaturesInstructions)
                .set('hasUnsavedChanges', true);
        },

        SET_HARDWARE_CHANGE(value) {
            return state.set('hardwareChange', value);
        },

        SET_UNSAVED_CHANGES(value) {
            return state.set('hasUnsavedChanges', value);
        },

        ADD_NEW_TRUCK(newTruck) {
            let updatedTrucks = state.get('trucks', List([])).unshift(newTruck);
            const _truckIndex = 0;
            const nextTruckIndex = updatedTrucks.size > 1 ? 1 : null;
            const prevTruckIndex = null;
            
            return state
                .set('selectedTruck', newTruck)
                .set('trucks', updatedTrucks)
                .set('selectedTruckIndex', _truckIndex)
                .set('nextTruckIndex', nextTruckIndex)
                .set('prevTruckIndex', prevTruckIndex)
                .set('hasUnsavedChanges', false)
                .set('readOnly', false);
        },

        ADD_TRUCK_TO_LIST(newTruck) {
            // Prepend the truck (e.g. a copy) without selecting it, so the detail
            // view does not open and the user stays on the dashboard list.
            return state.set('trucks', state.get('trucks', List([])).unshift(newTruck));
        },

        SET_ALL_TRUCKS(data) {
            return state
                .set('trucks', data)
        },

    }[action.type];

    return reduce == null ? state : reduce(action.payload);
}

export { TruckReducer };
export default TruckReducer;
